import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ResponsiveService } from '@prlw/libs/responsive/responsive.service';

@Component({
  selector: 'prlw-section-button-ui',
  templateUrl: './section-button.component.html',
  styleUrls: ['./section-button.component.scss'],
})
export default class SectionButtonComponent {
  @Input()
  active = false;

  @Input()
  label = 'Button';

  @Input()
  idEvent = 'idEvent';

  @Output()
  idEvents = new EventEmitter<string>();

  click() {
    this.idEvents.emit(this.idEvent);
  }

  constructor(private responsiveService: ResponsiveService) {}

  xsmall$ = this.responsiveService.xsmall$;
}
